<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app>
    <v-navigation-drawer v-model="$store.state.drawer" :clipped="$vuetify.breakpoint.lgAndUp" app dark>
      <v-list subheader>
        <v-list-item-group>
          <template v-for="item in $store.state.menuItems">
            <v-list-group v-if="item.items && item.items.length != 0" :key="item.id" no-action :value="item.active">
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-icon v-if="item.iconType === '0'">{{item.icon}}</v-icon>
                  <v-avatar size="24px" v-else>
                    <img :src="iconShow(item.icon)">
                  </v-avatar>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="ite in item.items">
                <!--                <v-list-item :key="ite.id" @click="itemClick(ite)" :href="ite.href">-->
                <v-list-item :key="ite.id" @click="itemClick(ite)" :to="ite.href">
                  <v-list-item-icon>
                    <v-icon v-if="ite.iconType === '0'">{{ite.icon}}</v-icon>
                    <v-avatar size="24px" v-else>
                      <img :src="iconShow(ite.icon)">
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="ite.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
            <!--            <v-list-item v-else :key="item.id" @click="itemClick(item)" :href="item.href">-->
            <v-list-item v-else :key="item.id" @click="itemClick(item)" :to="item.href">
              <v-list-item-icon>
                <v-icon v-if="item.iconType  === '0'">{{item.icon}}</v-icon>
                <v-avatar size="24px" v-else>
                  <img :src="iconShow(item.icon)">
                </v-avatar>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app dark>
      <v-app-bar-nav-icon @click.stop="$store.commit('reverseDrawer')" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">{{$vuetify.lang.t('$vuetify.custom.title')}}</span>
      </v-toolbar-title>
      <v-fab-transition>
        <v-btn color="red" small dark fixed style="margin-left: 13%" @click="downloadSource">
          <v-icon>mdi-cloud-download</v-icon>
          源码下载
        </v-btn>
      </v-fab-transition>
      <v-spacer />
      <!-- <v-btn icon class="mx-2">
        <v-icon>mdi-apps</v-icon>
      </v-btn>

      <v-btn icon class="mx-2">
        <v-icon>mdi-bell</v-icon>
      </v-btn> -->

      <v-menu offset-y dark transition="fab-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon large class="mx-2" v-on="on">
            <v-avatar size="32px">
              <v-img :src="require('../../../static/img/logo.png')" />
            </v-avatar>
          </v-btn>
        </template>
        <v-card class="mx-auto" width="300">
          <v-list disabled>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title">{{ $store.state.userInfo.userName }}</v-list-item-title>
                <v-list-item-subtitle>{{ $store.state.userInfo.realName }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list nav dense>
            <v-list-item-group color="primary">
              <v-list-item v-for="(item, i) in pullItems" :key="i">
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

            </v-list-item-group>
          </v-list>
          <v-divider></v-divider>
          <v-list nav dense>
            <v-list-item-group color="primary">
              <v-list-item @click="logout">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $vuetify.lang.t('$vuetify.custom.menu.logOUt') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
    <!-- 内容标签 -->
    <v-content v-resize="onResize">
      <template v-if="!$vuetify.breakpoint.xs">
        <v-sheet align-with-title style="position: fixed;width: 100%;z-index: 5;">
          <v-tabs center-active color="#FFF">
            <v-tab v-for="(tItem,index) in tabItem" :key="index" :to="tItem.href">
              {{ tItem.name }}
              <a @click.stop.prevent="onTabClose(tItem)" class="ml-2" v-if="tItem.name != '主页'">
                <v-icon small color="#FFF">mdi-close</v-icon>
              </a>
            </v-tab>
          </v-tabs>
        </v-sheet>
        <v-container fluid class="mt-12">
          <router-view></router-view>
        </v-container>
      </template>
      <template v-else>
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </template>
    </v-content>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <download @childHidden="childHidden"></download>
    </v-dialog>
  </v-app>
</template>

<script>
  // import Vue from 'vue'
  // export const eventHub = new Vue()
  import download from './download'
  export default {
    components: {
      download
    },
    props: {
      source: String,
    },
    data() {
      return {
        dialog: false,
        //drawer: false,
        pullItems: [{
            text: this.$vuetify.lang.t('$vuetify.custom.menu.setUpState'),
            icon: 'mdi-folder'
          },
          {
            text: this.$vuetify.lang.t('$vuetify.custom.menu.userInformation'),
            icon: 'mdi-account-multiple'
          },
          {
            text: this.$vuetify.lang.t('$vuetify.custom.menu.setUp'),
            icon: 'mdi-star'
          },
        ],
        tabItem: this.$store.state.tabItem,
      }
    },
    computed: {
      iconShow(icon) {
        return function(icon) {
          if (icon.length == 32) {
            return this.$file.fileDownload(icon)
          }
          return icon
        }
      }
    },
    mounted() {
      // 页面刷新前缓存和赋值
      // this.beforeIndexUnload();
    },
    methods: {
      logout() {
        //this.$api.sys.logout().then(data=>{
        this.$store.commit('del_token');
        this.$router.push("/")
        //})
      },
      itemClick(item) {
        let x = this.tabItem.find((x) => x && x.id == item.id);
        if (x) return;
        this.$store.commit('addTabItem', item);
      },
      onTabClose(item) {
        var id = this.tabItem[this.tabItem.length - 1].id;
        //this.tabItem.splice(this.tabItem.indexOf(item), 1);
        this.$store.commit('spliceTabItem', item);
        if (id == item.id || this.$router.currentRoute.path == item.href) {
          this.$router.push(this.tabItem[this.tabItem.length - 1].href);
        }
      },
      onResize() {
        let height = 0
        if (this.$vuetify.breakpoint.xs) {
          height = window.innerHeight - 64 - 12
        } else {
          height = window.innerHeight - 64 - 48 - 24
        }
        this.$store.commit('setMaxHeight', height);
      },
      beforeIndexUnload() {
        window.addEventListener("beforeunload", () => {
          sessionStorage.setItem("tabViews", JSON.stringify(this.tabItem));
        });
        let tabViews = sessionStorage.getItem("tabViews");
        if (tabViews) {
          tabViews = JSON.parse(tabViews);
          tabViews.forEach((item, index) => {
            if (!index) return;
            if (this.tabItem.indexOf(item) != -1) return;
            this.tabItem.push(item);
          })
        }
      },
      childHidden() {
        this.dialog = false;
      },
      downloadSource() {
        this.dialog = true;
      },
      /* loadMenu() {
          this.$api.sysPermission.selectMenuList().then(data => {
            let items = this.$utils.menu.sortMenu(data.data)
            this.$store.commit('setMenuItems',items);
          })
      }, */
    },
    created() {
      console.log("%c了不起的年轻人~\r\n欢迎加入我们~\r\n简历请发到669688@qq.com","color:blue")
      //this.loadMenu();
      this.$store.commit('changeDrawerOn');
      this.$vuetify.theme.dark = true
    }
  }
</script>
<style>
  ::-webkit-scrollbar {
    width: 1px;
    height: 1px;
    /**/
  }

  ::-webkit-scrollbar-track {
    background: #000;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background: #FAFAFA;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #FAFAFA;
  }

  ::-webkit-scrollbar-corner {
    background: #000;
  }
</style>



// WEBPACK FOOTER //
// src/page/index/index.vue